import apiServices from './apiServices'

export default class extends apiServices {
  // téléchargement du rapport
  static downloadReport (campingId) {
    return this.download('/api/document/report/' + campingId)
  }
}
